import { Code, Group, Stack, Text } from "@mantine/core";
import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { EffectRow } from "./EffectRow";

export const RuleEngineEffectSetMetadataFragment = graphql(`
  fragment RuleEngineEffectSetMetadataFields on RuleEngineEffectSetMetadataPayload {
    __typename
    effectKind
    targetType
    targetId
    key
    beforeValueJson
    afterValueJson
    applied
    skipReason
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineEffectSetMetadataFragment>;
}

export function RuleEngineEffectSetMetadataPayload({ data }: Props) {
  const p = readFragment(RuleEngineEffectSetMetadataFragment, data);
  return (
    <Stack gap={4}>
      <EffectRow
        applied={p.applied}
        appliedColor="blue"
        appliedLabel="SET_METADATA"
        skipReason={p.skipReason}
      >
        {p.targetType} {p.targetId.slice(0, 8)} · key{" "}
        <Text span ff="monospace">
          {p.key}
        </Text>
      </EffectRow>
      <Group gap="xs" wrap="wrap" align="flex-start">
        <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
          <Text size="xs" c="dimmed">
            before
          </Text>
          <Code block>{p.beforeValueJson ?? "null"}</Code>
        </Stack>
        <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
          <Text size="xs" c="dimmed">
            after
          </Text>
          <Code block>{p.afterValueJson ?? "null"}</Code>
        </Stack>
      </Group>
    </Stack>
  );
}
